import { UserApi } from '@typings/entities/User'
import gql from 'graphql-tag'

export type UsersGetQueryResult = {
  data: {
    usersGet: {
      results: UserApi[]
    }
  }
}

const usersGetQuery = gql`
  query usersGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object, $nested: boolean) {
    usersGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "UsersResult", method: "POST", path: "user/list") {
      results
      paging
    }
  }
`

export default usersGetQuery
